import {
    propertyTypeSelector,
    updateFilter
} from '@zoopla/redux-reducer-filters';
import {
    FilterOptions,
    PropertyTypes
} from '@zoopla/redux-types/filters.types';
import { ChangeEvent, FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    FilterWrapper,
    PropertyTypeFilterLabel,
    PropertyTypeRadio,
    StyledRadio
} from './SearchInitiationMobile.styles';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

type PropertyTypeRadioOptions = {
    options: FilterOptions;
    onPropertyTypeChange: (evt: ChangeEvent<HTMLInputElement>) => void;
    propertyType: string | string[];
};

const PropertyTypeRadioButtonWrapper = styled.div(
    () => css`
        display: flex;
        flex-wrap: wrap;
    `
);

const PropertyTypeRadioButtons: FC<PropertyTypeRadioOptions> = ({
    options,
    onPropertyTypeChange,
    propertyType
}) => {
    return (
        // see: https://github.com/yannickcr/eslint-plugin-react/issues/2584
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
            {options?.map((option) => {
                const { label, value } = option;

                const idKey = `mobile_property_type_option${
                    value ? `_${value}` : '_all'
                }`;

                const hasSelectedThisPropertyType = propertyType === value;

                return (
                    <PropertyTypeRadio key={`${value}-${label}`}>
                        <StyledRadio
                            key={`${value}-${label}`}
                            id={idKey}
                            data-testid={value}
                            name="propertyTypeOption"
                            label={label}
                            value={value}
                            checked={hasSelectedThisPropertyType}
                            onChange={onPropertyTypeChange}
                        />
                    </PropertyTypeRadio>
                );
            }) ?? []}
        </>
    );
};

export const SelectPropertyType: FC<{
    excludePropertyTypes?: PropertyTypes;
}> = ({ excludePropertyTypes = [] }) => {
    const reduxDispatch = useDispatch();
    const {
        selectedValue: propertyTypeSelectedValue,
        options: propertyTypeOptions
    } = useSelector(propertyTypeSelector);

    const filteredPropertyTypeOptions = propertyTypeOptions.filter(
        (propertyTypeOption) =>
            !excludePropertyTypes.includes(propertyTypeOption.value as never)
    );

    const onPropertyTypeChange = (evt: ChangeEvent<HTMLInputElement>) => {
        reduxDispatch(updateFilter('propertyType', evt.currentTarget.value));
    };

    const propertyTypeLabel = 'Property type';

    return (
        <FilterWrapper>
            <PropertyTypeFilterLabel htmlFor="modal-property-type-filter">
                {propertyTypeLabel}
            </PropertyTypeFilterLabel>
            <PropertyTypeRadioButtonWrapper>
                <PropertyTypeRadioButtons
                    onPropertyTypeChange={onPropertyTypeChange}
                    propertyType={propertyTypeSelectedValue}
                    options={filteredPropertyTypeOptions}
                />
            </PropertyTypeRadioButtonWrapper>
        </FilterWrapper>
    );
};
